import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export function ImprintPage() {
  return (
    <div>
      <Seo
        title="Impressum / Imprint – Mezzbridge"
        description="Impressum der 2besales GmbH – Mezzbridge."
        lang="de"
        noindex
      />
      <div className="legal-wrap" data-testid="imprint-page">
        <p><Link to="/" className="legal-back">← Mezzbridge</Link></p>
        <h1>Impressum / Imprint</h1>
        <p>Angaben gemäß § 5 DDG / Information pursuant to § 5 DDG</p>
        <p>
          <strong>2besales GmbH</strong><br />
          Lena-Christ-Str. 2<br />
          82031 Grünwald<br />
          Deutschland / Germany
        </p>
        <p>Vertreten durch den Geschäftsführer / Represented by the Managing Director: Patrick Häfner</p>
        <p>
          Registergericht / Register court: Amtsgericht München<br />
          Registernummer / Register number: HRB 293569
        </p>
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG / VAT ID: DE368739520</p>
        <p>
          Telefon / Phone: <a href="tel:+4989540489383">+49 89 540489383</a><br />
          E-Mail: <a href="mailto:info@2besales.de">info@2besales.de</a>
        </p>
        <p>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV / Responsible for content: Patrick Häfner, Anschrift wie oben / address as above</p>
        <h2>Hinweis zur Tätigkeit / Notice on our activity</h2>
        <p>Mezzbridge ist ein Service der 2besales GmbH. Die 2besales GmbH ist ausschließlich als Tippgeber tätig, vermittelt selbst keine Finanzierungen und erbringt keine Anlage-, Finanz-, Rechts- oder Steuerberatung. Die Vermittlung erfolgt ausschließlich durch einen Makler mit Erlaubnis nach § 34c GewO.</p>
        <p>Mezzbridge is a service of 2besales GmbH. 2besales GmbH acts solely as an introducer, does not broker financing itself and provides no investment, financial, legal or tax advice. Brokerage is carried out exclusively by a broker licensed under § 34c of the German Trade Regulation Act (GewO).</p>
        <h2>Verbraucherstreitbeilegung / Consumer dispute resolution</h2>
        <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        <p>We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.</p>
      </div>
    </div>
  );
}
